import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ROLES_CAN_SEE_EXERCISES_ALWAYS } from '../config/permissionsList';

/**
 * حماية مسار بناءً على الصلاحيات (وربما الأدوار)
 * @param {string|string[]} requiredPermission - صلاحية مطلوبة أو مصفوفة (any)
 * @param {string[]} allowedRoles - إن وُجد، المستخدم يجب أن يكون أحد هذه الأدوار (مع الصلاحية)
 * @param {boolean} exercisesVisibility - إن كان true يُطبَّق منطق التمارين اليومية: أدمن وأدمن متقدم فقط
 */
const PermissionRoute = ({
  requiredPermission,
  requiredPermissions,
  permissionMode = 'any',
  redirectTo = '/dashboard',
  allowedRoles,
  exercisesVisibility,
  children
}) => {
  const { hasAnyPermission, hasAllPermissions, hasAnyRole, loading } = useAuth();

  if (loading) return null;

  const perms = requiredPermissions || (requiredPermission ? [requiredPermission] : []);
  let hasAccess = perms.length === 0 || (permissionMode === 'all' ? hasAllPermissions(perms) : hasAnyPermission(perms));

  if (hasAccess && allowedRoles && allowedRoles.length > 0) {
    hasAccess = hasAnyRole(allowedRoles);
  }
  if (exercisesVisibility) {
    hasAccess = hasAnyRole(ROLES_CAN_SEE_EXERCISES_ALWAYS);
  }

  if (!hasAccess) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default PermissionRoute;
